import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import PulsingLinesThrobber from "../../../Common/components/PulsingLinesThrobber";

import LloydCartFields from "./LloydCartFields";
import LloydCart from "../models/LloydCart";

export default function SubmittingFormBottom({lloydCart}) {
  return <section id="lloyd-item-section-bottom">
    <PulsingLinesThrobber/>
    <div id="lloyd-item-section-bottom-submit">
      <button className="btn" type="button" disabled="true">Please Wait...</button>
    </div>
    <LloydCartFields lloydCart={lloydCart} />
  </section>
}

SubmittingFormBottom.propTypes = {
  lloydCart: PropTypes.instanceOf(LloydCart).isRequired,
  callbacks: PropTypes.object.isRequired
}
